module.exports = __webpack_public_path__ + "img/bukopin.0e1e5097.png";